import { schemaToCodec } from '@main/schema-utils/src/schemaToCodec';

import { RequestsProcessedDisclosureStatOverride } from './schema';

export const RequestsProcessedDisclosureStatOverrideCodec = schemaToCodec(
  RequestsProcessedDisclosureStatOverride,
);
